import Enumerable from "linq";
import { Command, HttpMethod } from "~/extensions/api";
export class UpdateShinjoshoCommand extends Command {
    constructor(model, personal, kouzaNumber) {
        super(HttpMethod.Post, "keiyaku/update");
        this.nyukyokeiyakuNo = model.nyukyokeiyakuNo;
        this.kouza = new KouzaParameter(kouzaNumber, personal);
        this.workPlace = new WorkPlaceParameter(model.workPlace);
        this.emergencyContact = new EmergencyParameter(model.emergencyContact);
        this.kyojushas = Enumerable.from(model.kyojushas)
            .select(x => new KyojushaParameter(x))
            .toArray();
        this.car = new CarParameter(model.car);
        this.insurance = new InsuranceParameter(model.insurance);
    }
    nyukyokeiyakuNo = -1;
    kouza = new KouzaParameter();
    workPlace = new WorkPlaceParameter();
    emergencyContact = new EmergencyParameter();
    kyojushas = [];
    car = new CarParameter();
    insurance = new InsuranceParameter();
}
/**口座情報 */
class KouzaParameter {
    constructor(kouzaNumber = "", personal = null) {
        if (personal === null || personal.kouzaSb === 0) {
            return;
        }
        this.bankCd = personal.bankCd;
        this.bankName = personal.bankName;
        this.bansCd = personal.bansCd;
        this.bansName = personal.bansName;
        this.kouzaSb = personal.kouzaSb;
        this.kouzaNumber = kouzaNumber;
        this.kouzaName = personal.kouzaName;
        this.kouzaKana = personal.kouzaKana;
    }
    bankCd = null;
    bankName = "";
    bansCd = null;
    bansName = "";
    kouzaSb = null;
    kouzaNumber = "";
    kouzaName = "";
    kouzaKana = "";
}
/**勤務先情報 */
class WorkPlaceParameter {
    constructor(model = null) {
        if (model === null) {
            return;
        }
        this.workplaceName = model.workplaceName;
        this.yearsOfService = model.yearsOfService;
        this.workplaceTel = model.workplaceTel;
        this.workplacePostcode = model.workplacePostcode;
        this.address1 = model.address1;
        this.address2 = model.address2;
        this.address3 = model.address3;
    }
    workplaceName = "";
    yearsOfService = null;
    workplaceTel = "";
    workplacePostcode = "";
    address1 = "";
    address2 = "";
    address3 = "";
}
class EmergencyParameter {
    constructor(model = null) {
        if (model === null) {
            return;
        }
        this.name = model.name;
        this.dateOfBirth = model.dateOfBirth;
        this.tel = model.tel;
        this.postCode = model.postCode;
        this.address1 = model.address1;
        this.address2 = model.address2;
        this.address3 = model.address3;
        this.workplaceName = model.workplaceName;
        this.yearsOfService = model.yearsOfService;
        this.workplaceTel = model.workplaceTel;
        this.workplacePostcode = model.workplacePostcode;
        this.workplaceAddress1 = model.workplaceAddress1;
        this.workplaceAddress2 = model.workplaceAddress2;
        this.workplaceAddress3 = model.workplaceAddress3;
    }
    name = "";
    dateOfBirth = "";
    tel = "";
    postCode = "";
    address1 = "";
    address2 = "";
    address3 = "";
    workplaceName = "";
    yearsOfService = null;
    workplaceTel = "";
    workplacePostcode = "";
    workplaceAddress1 = "";
    workplaceAddress2 = "";
    workplaceAddress3 = "";
}
class KyojushaParameter {
    constructor(model = null) {
        if (model === null) {
            return;
        }
        this.name = model.name;
        this.dateOfBirth = model.dateOfBirth;
        this.tel = model.tel;
        this.relationship = model.relationship;
    }
    name = "";
    dateOfBirth = "";
    tel = "";
    relationship = "";
}
class CarParameter {
    constructor(model = null) {
        if (model === null) {
            return;
        }
        this.manufacturer = model.manufacturer;
        this.carModel = model.carModel;
        this.carColor = model.carColor;
        this.displacement = model.displacement;
        this.registrationNumber = model.registrationNumber;
    }
    manufacturer = "";
    carModel = "";
    carColor = "";
    displacement = null;
    registrationNumber = "";
}
class InsuranceParameter {
    constructor(model = null) {
        if (model === null) {
            return;
        }
        this.insuranceCompany = model.insuranceCompany;
        this.insurancetype = model.insuranceType;
        this.contractStartDate = model.contractStartDate;
        this.contractEndDate = model.contractEndDate;
    }
    insuranceCompany = "";
    insurancetype = "";
    contractStartDate = "";
    contractEndDate = "";
}
